module.exports = __webpack_public_path__ + "img/xbody-asset-4.9c076251.svg";